import Vue from 'vue'
import moment from 'moment'

import App from './App.vue'
import router from './router'
import store from './store'
import { sesstionStore, ModalHelper, formateDate } from '@/utils/utils'

import './plugins/vant.js'
import './plugins/filter'
import './directives'
import './assets/styles/common.scss'
import './assets/styles/index.scss'
import './assets/styles/iconfont.css'
import './assets/styles/quill.core.css'
import { auth } from '@/utils/handle_app'

moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.prototype.$ss = sesstionStore
Vue.prototype.$modalHelper = ModalHelper
Vue.prototype.$formatDate = formateDate
Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false
Vue.prototype.$oss = (url) =>
  `https://dyyy-static.oss-cn-shenzhen.aliyuncs.com/sfc-assets/h5/${url}.png`
Vue.prototype.$dyyy = (url) =>
  `https://dyyy-static.oss-cn-shenzhen.aliyuncs.com/serveice/${url}.png`
;(async () => {
  await auth()
})()

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
